<template>
  <div class="ShieldSearchCarDialog" v-if="showDialog">
    <div class="icon-box" style="z-index:2019">
        <div class="icon">
          <img src="../../assets/images/search/icon_risk.png" alt="" srcset="">
        </div>
    </div>
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">风险提示</div>
        <div class="tips">
          该车要求<span>屏蔽定位</span>，请<span>谨慎合作</span>，防范货物运输风险。
        </div>
        <div class="careful">注:您可联系该车开通定位或更换合作车辆</div>
        <div class="btn flex" @click="showDialog=false">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    /**
     * 显示开通体验vip弹框
    */
    showPopup () {
      this.showDialog = true
    },
  },
};
</script>

<style scoped lang="scss">
.ShieldSearchCarDialog>:nth-child(2) {
  background-color: rgba(0,0,0,.4)
}
.ShieldSearchCarDialog>:nth-child(3) {
  border-radius: 12px;
  width: 80%
}
.ShieldSearchCarDialog {
  .icon-box {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2019;
    margin-left: -75px;
    margin-top: -280px;
    .icon {
      text-align: center;
      img {
        width: 150px;
      }
    }
  }
  .content {
    padding: 30px 30px;
    background-color: #ffffff;
    .title {
      color: #282828;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      margin-top: 60px;
    }
    .tips {
      color: #282828;
      font-size: 26px;
      padding: 20px 0;
      span {
        color: #FF3C3C;
      }
    }
    .careful {
      color: #989898;
      font-size: 22px;
    }
    .btn {
      background-color: #5277FF;
      color: #ffffff;
      height: 80px;
      border-radius: 6px;
      margin-top: 30px;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
